module.exports = __webpack_public_path__ + "media/country_flags/sy-81abe64e.png";